// Record of Movement "points in correct position" and "level crossing
// instructions given" are Yes/N-A toggles. Only an explicit Yes counts as Yes;
// anything else (blank, null, off, "na") means the toggle was not activated,
// which is shown as N/A on every screen.
const YES_VALUES = ["yes", "y", "true", "1", "on"];

export const isMovementYes = (value) => {
  if (value === true || value === 1) return true;
  if (typeof value !== "string") return false;
  return YES_VALUES.includes(value.trim().toLowerCase());
};

export const movementAnswerLabel = (value) => (isMovementYes(value) ? "Yes" : "N/A");
